import React from 'react';
import { Quote } from 'lucide-react';
import styles from './Testimonials.module.css';

const testimonials = [
  {
    quote: 'BlueprintX turned our stalled AI initiative into a production system in 8 weeks. No other partner came close to that velocity.',
    name: 'VP of Engineering',
    company: 'Financial Services',
  },
  {
    quote: 'They embedded with our team and operated like co-founders, not consultants. The accountability was refreshing.',
    name: 'CTO',
    company: 'Series B HealthTech Startup',
  },
  {
    quote: 'We went from 5 vendors to 1 integrated partner. Costs dropped 40% and delivery speed tripled.',
    name: 'Head of Digital',
    company: 'European Logistics Enterprise',
  },
  {
    quote: 'In the era of mixed Outcomes, BlueprintX proved their expertise in driving efficiency and increasing Productivity through AI/ML.',
    name: 'Head of IT',
    company: 'Textile Manufacturing',
  },
];

// Duplicate the array to create the seamless infinite scroll effect
const marqueeItems = [...testimonials, ...testimonials];

const Testimonials = () => {
  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.header}>
          <span className={styles.tag}>WHAT CLIENTS SAY</span>
          <h2 className={styles.heading}>Outcomes Speak Louder Than Pitch Decks</h2>
          <p className={styles.subtitle}>
            Clients consistently report: faster delivery, fewer vendors, and measurable ROI — not theoretical outcomes.
          </p>
        </div>
      </div>

      {/* Full-bleed marquee — escapes container for seamless scroll */}
      <div className={styles.marqueeWrapper}>
        <div className={styles.marqueeTrack}>
          {marqueeItems.map((t, i) => (
            <div key={i} className={styles.card} aria-hidden={i >= testimonials.length}>
              <Quote size={28} className={styles.quoteIcon} />
              <p className={styles.quoteText}>{t.quote}</p>
              <div className={styles.author}>
                <span className={styles.authorName}>{t.name}</span>
                <span className={styles.authorCompany}>{t.company}</span>
              </div>
            </div>
          ))}
        </div>
        {/* Edge fades */}
        <div className={`${styles.fade} ${styles.fadeLeft}`} aria-hidden="true" />
        <div className={`${styles.fade} ${styles.fadeRight}`} aria-hidden="true" />
      </div>
    </section>
  );
};

export default Testimonials;
